import React from "react"

// import Navdrawer from "./navdrawer"
import * as styles from "../../styles/components/navbar.module.scss"

import logo from "../../images/logo.png"
import social1 from "../../images/social1.png"
import social2 from "../../images/social2.png"
import social3 from "../../images/social3.png"

const Navbar = () => {
  return (
    <div className={styles.navbar}>
      <div className={styles.navbar__header}>
        <div className={styles.navbar__social}>
          <h4>Connect With Us</h4>
          <a href="mailto:info@newmacaucasino.com" target="_top blank">
            <img src={social1} alt="email" />
          </a>
          <a href="https://www.facebook.com/newmacaucasino" target="blank">
            <img src={social2} alt="fb" />
          </a>
          <a href="https://www.instagram.com/newmacaucasino/" target="blank">
            <img src={social3} alt="ig" />
          </a>
        </div>
      </div>
      {/* Main Navigation */}
      <div className={styles.navbar__main}>
        <div className={styles.navbar__logo}>
          <img src={logo} alt="logo" />
          <a href="https://www.newmacaucasino.com/en/" target="_blank">
            <p style={{marginTop:"8px"}}>Visit Our Main Page</p>
          </a>
        </div>
      </div>
    </div>
  )
}

export default Navbar
